import React, { useCallback, useEffect, useState, Component } from 'react';
import { Sidebar } from './components/Sidebar';
import { ProjectsContent, PROJECTS } from './components/ProjectsContent';
import { ProjectDetailPage } from './components/ProjectDetailPage';
import { ConsentFilter } from './components/ConsentsTab';
function parseHash(): {
  projectId: number | null;
  tab: string;
} {
  const hash = window.location.hash.replace('#', '');
  if (!hash || hash === 'projects') {
    return {
      projectId: null,
      tab: 'Overview'
    };
  }
  // Format: project/{id}/{tab}
  const parts = hash.split('/');
  if (parts[0] === 'project' && parts[1]) {
    const id = parseInt(parts[1], 10);
    const tab = parts[2] ? decodeURIComponent(parts[2]) : 'Overview';
    return {
      projectId: isNaN(id) ? null : id,
      tab
    };
  }
  return {
    projectId: null,
    tab: 'Overview'
  };
}
function buildHash(projectId: number | null, tab: string): string {
  if (projectId === null) return '#projects';
  return `#project/${projectId}/${encodeURIComponent(tab)}`;
}
export function App() {
  const initial = parseHash();
  const initialProject = initial.projectId ? PROJECTS.find(p => p.id === initial.projectId) || null : null;
  const [selectedProject, setSelectedProject] = useState<any>(initialProject);
  const [activeTab, setActiveTab] = useState(initial.tab);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Update hash when state changes
  useEffect(() => {
    const newHash = buildHash(selectedProject?.id || null, activeTab);
    if (window.location.hash !== newHash) {
      window.location.hash = newHash;
    }
  }, [selectedProject, activeTab]);
  // Listen for back/forward browser navigation
  useEffect(() => {
    const onHashChange = () => {
      const {
        projectId,
        tab
      } = parseHash();
      if (projectId === null) {
        setSelectedProject(null);
        setActiveTab('Overview');
      } else {
        const project = PROJECTS.find(p => p.id === projectId);
        if (project) {
          setSelectedProject(project);
          setActiveTab(tab);
        }
      }
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  const handleSelectProject = useCallback((project: any) => {
    setSelectedProject(project);
    setActiveTab('Overview');
  }, []);
  const handleSidebarProjectSelect = useCallback((id: number) => {
    const project = PROJECTS.find(p => p.id === id);
    if (project) {
      setSelectedProject(project);
      setActiveTab('Overview');
    }
  }, []);
  const handleBack = useCallback(() => {
    setSelectedProject(null);
    setActiveTab('Overview');
  }, []);
  const handleTabChange = useCallback((tab: string) => {
    setActiveTab(tab);
  }, []);
  return <div className="flex h-screen w-full bg-white overflow-hidden font-sans text-gray-900" data-id="element-0">
      <Sidebar collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(prev => !prev)} onProjectSelect={handleSidebarProjectSelect} onHomeSelect={() => {
      setSelectedProject(null);
      setActiveTab('Overview');
    }} data-id="element-1" />
      <main className="flex-1 overflow-y-auto relative" data-id="element-2">
        {selectedProject ? <ProjectDetailPage project={selectedProject} onBack={handleBack} activeTab={activeTab} onTabChange={handleTabChange} data-id="element-3" /> : <ProjectsContent onProjectSelect={handleSelectProject} data-id="element-4" />}
        <div className="px-6 py-4 text-xs text-gray-500 italic border-t border-gray-200 bg-white leading-relaxed" data-id="element-5">
          Disclaimer: This platform is provided on a confidential basis solely
          for the use of the recipient. The content and features presented are
          part of a beta version of the AltConvey platform and are subject to
          change. All information displayed is for illustrative purposes only
          and should not be relied upon as legal, financial, or investment
          advice. Users are solely responsible for verifying any information
          independently. By accessing this platform, you agree not to disclose,
          reproduce, or distribute any part of its contents without prior
          written consent.
        </div>
      </main>
    </div>;
}